import { action, makeObservable, observable } from "mobx";
import BaseObjectStore, { BaseObjectStoreParams } from "../BaseObjectStore";
import type { ISignalsTextCard } from "../../SignalsModels";

// Text cards are static content; no async fetch required.
class TextCardStore extends BaseObjectStore<null, null> {
    @observable cardText: string;

    constructor({
        baseObject,
        rootStore,
        options,
        initialData,
        refreshOnCreate,
    }: BaseObjectStoreParams<null, ISignalsTextCard>) {
        super({ baseObject, rootStore, options, initialData, refreshOnCreate });
        makeObservable(this);
        this.cardText = baseObject.cardText;
    }

    @action
    setCardText = (text: string) => {
        this.cardText = text;
    };

    public async getData(): Promise<null> {
        return null;
    }
}

export default TextCardStore;
